import { render, staticRenderFns } from "./BenefitsModal.vue?vue&type=template&id=428a6f84&scoped=true&"
import script from "./BenefitsModal.vue?vue&type=script&lang=ts&"
export * from "./BenefitsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428a6f84",
  null
  
)

export default component.exports